import * as _ from "lodash";
import http from "../constant/api";

export const messageService = {
    queryMessageBySessionId: async (sessionId, filter) => {
    const result = await http.get(`/api/message/session-id/${sessionId}/query`, {
      params: filter,
    });

    return result;
  },
  sendMessage: async (data, isFormData = false) => {
    const result = await http.post(`/api/message/send`, data, {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    });

    return result;
  },
  editMessage: async (id, data) => {
    const result = await http.put(`/api/message/${id}/edit`, data);

    return result;
  },
  readMessage: async (id) => {
    const result = await http.get(`/api/message/${id}`);

    return result;
  },
};
